import { get } from 'lodash';
import { ALS_ERLEDIGT_MARKIEREN_LABEL } from 'src/lib/constants/constant';
import MittelabrufSchema from 'src/lib/paths/mittelabruf_FULL_Paths.json';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue } from 'src/lib/validation/ValidationTypes';
import { checkIfPruefAssitenzNeedsToValidate } from 'src/pages/private/online-antrag/application-helper-function/AppHelperfunctions';
import { addIndexesToPath, getFieldNamefromDataPath } from 'src/utils/helper';

type SchemaField = { path: string; type: string; [key: string]: any };

type NachweisSchemaAttributes = {
	Pruefung_Pruefstatus: SchemaField;
	Pruefung_Hinweis_Fuer_Den_Antragsteller: SchemaField;
	Pruefung_Ueberarbeitet_Am: SchemaField;
	Pruefung_Erledigt: SchemaField;
	Allgemein_Ausgaben_Kosten: SchemaField;
};
const MA_P = MittelabrufSchema.attributes;

type PruefAssistenzPaths = {
	statusPath: string;
	hinweisPath: string;
	ueberarbeitetAmPath: string;
	erledigtPath: string;
};

const getNachweisPositionIndex = (application: any, predicate: (eachPosition: any) => boolean) => {
	const nachweispositionen = get(application, MA_P.Mittelabruf_Nachweispositions.path, []);
	const index = (nachweispositionen as any[]).findIndex(predicate);
	return index;
};

export const getNachweisPruefAssistenzPaths = (application: any, predicate: (eachPosition: any) => boolean): PruefAssistenzPaths => {
	const index = getNachweisPositionIndex(application, predicate);
	const nachweisAttributes = MA_P.Mittelabruf_Nachweispositions.schema.attributes;

	return {
		statusPath: addIndexesToPath(
			nachweisAttributes.Pruefung_Pruefstatus.path,
			[`${index}`],
			[getFieldNamefromDataPath(MA_P.Mittelabruf_Nachweispositions.path)],
		),
		hinweisPath: addIndexesToPath(
			nachweisAttributes.Pruefung_Hinweis_Fuer_Den_Antragsteller.path,
			[`${index}`],
			[getFieldNamefromDataPath(MA_P.Mittelabruf_Nachweispositions.path)],
		),
		ueberarbeitetAmPath: addIndexesToPath(
			nachweisAttributes.Pruefung_Ueberarbeitet_Am.path,
			[`${index}`],
			[getFieldNamefromDataPath(MA_P.Mittelabruf_Nachweispositions.path)],
		),
		erledigtPath: addIndexesToPath(
			nachweisAttributes.Pruefung_Erledigt.path,
			[`${index}`],
			[getFieldNamefromDataPath(MA_P.Mittelabruf_Nachweispositions.path)],
		),
	};
};

export const getNachweisAusgabenPath = (application: any, predicate: (eachPosition: any) => boolean) => {
	const index = getNachweisPositionIndex(application, predicate);

	return addIndexesToPath(
		MA_P.Mittelabruf_Nachweispositions.schema.attributes.Allgemein_Ausgaben_Kosten.path,
		[`${index}`],
		[getFieldNamefromDataPath(MA_P.Mittelabruf_Nachweispositions.path)],
	);
};

export const formStrucPruefAssistenz = (erledigtPath: string) => {
	const nachweisAttributes = MA_P.Mittelabruf_Nachweispositions.schema.attributes as NachweisSchemaAttributes;
	const struc: FormStrucItem[] = [
		{
			fields: [
				{
					...nachweisAttributes.Pruefung_Erledigt,
					path: erledigtPath,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];

	return struc;
};

export const shouldValidatePruefAssistenz = (application: any, paths: PruefAssistenzPaths) => {
	return checkIfPruefAssitenzNeedsToValidate(application, paths.statusPath, paths.erledigtPath);
};
